import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import BonusContainer from '../BonusContainer/BonusContainer';
import BonusInput from '../BonusInput/BonusInput';

import {
  TXTWCL_Got_your_own_codeX,
  TXTWCL_Use_your_own_code,
  TXTWCL_You_can_add_it_hereX
} from './OwnBonusCode.messages.json';
import { container, description, section, visible } from './OwnBonusCode.scss';

interface Props {
  selected?: boolean;
}

const OwnBonusCode: React.FC<Props> = ({ selected }) => (
  <BonusContainer selected={selected} title={TXTWCL_Use_your_own_code}>
    <div className={description}>
      <Translation {...TXTWCL_Got_your_own_codeX} />{' '}
      <Translation {...TXTWCL_You_can_add_it_hereX} />
    </div>
    <div className={classNames(section, selected && visible)}>
      <hr />
      <div className={container}>
        <BonusInput selected={selected} />
      </div>
    </div>
  </BonusContainer>
);

export default OwnBonusCode;
